import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { type IExportState, type ILayerProps, type StateType } from '@/version-types';

export enum EDeformationImgType {
    PERSPECTIVE = 'perspective',
    DISTORTION = 'distortion',
}

/** 状态 */
interface IState {
    isDeformationImage: boolean;
    isOperation: boolean;
    currentType: EDeformationImgType;
    layerImage: HTMLCanvasElement | null;
    isSaving: boolean;
    currentLayer: ILayerProps | null;
}

/** 动作 */
interface IAction {
    setIsDeformationImage: (isDeformationImage: boolean) => void;
    setIsOperation: (isOperation: boolean) => void;
    setCurrentType: (currentType: EDeformationImgType) => void;
    setLayerImage: (layerImage: HTMLCanvasElement | null) => void;
    setIsSaving: (isSaving: boolean) => void;
    setCurrentLayer: (currentLayer: ILayerProps | null) => void;
    reset: () => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
export function getInitialState() {
    return {
        isDeformationImage: false,
        isOperation: false,
        currentType: EDeformationImgType.PERSPECTIVE,
        layerImage: null,
        isSaving: false,
        currentLayer: null,
    };
}

/** 创建存储 */
const createState = (_identity: string) => {
    const store = create<IStore>((set) => ({
        ...getInitialState(),

        setIsDeformationImage: (isDeformationImage) => {
            set({ isDeformationImage });
        },

        setIsOperation: (isOperation) => {
            set({ isOperation });
        },

        setCurrentType: (currentType) => {
            set({ currentType });
        },

        setLayerImage: (layerImage) => {
            set({ layerImage });
        },

        setIsSaving: (isSaving) => {
            set({ isSaving });
        },
        setCurrentLayer: (currentLayer) => set({ currentLayer }),
        reset: () => set(getInitialState()),
    }));

    return store;
};

/** 存储名称 */
const name = 'deformation-img-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useDeformationImgState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getDeformationImgState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
